// import { version } from '../../package.json';
import pkg from '../../package.json';

const hostname = window.location.hostname

// extract subdomain
const parts = hostname.split('.')
const labName = parts.length > 2 ? parts[0] : null;

// build urls
const apiBase = labName
  ? `https://${labName}.dormotech.app`
  : `https://dormotech.app`;

export const environment = {
  testPrefix: 'CU-TEST_',
  appVersion: pkg.version,
  production: true,
  namespace: 'root',
  sentryDsn: 'https://25b290f85dc94e68990d5e92562eeffc@o4507973272141824.ingest.us.sentry.io/4509388801245184',
  /*
   * Google Analytics 4 roll-up property: every lab reports here, and the `lab`
   * user property (taken from the subdomain) is what splits the reports by lab.
   * Analytics stays inert until this holds a real `G-...` id.
   */
  gaMeasurementId: 'YOUR_GA_MEASUREMENT_ID_HERE',
  labName,
  /* BACKEND */
  apiUrl: `${apiBase}/api/`,
  /* SOCKET */
  socketUrl: labName
    ? `https://io.${labName}.dormotech.app`
    : `https://io.dormotech.app`,
  /* LC license */
  licenseKey: '0002-vWs81F5D66T1wUypq17slKxE+ui02gJvPNJeQ+uw7sBAkdA6uzxivAdAOjxzdk6rBhKtUGbmk3b1Cd07a0AxV2KR8jLFS1XPL9PlTAG9EgHhMMlY17CJRzj/PkJ12oeDAAFb5+2JiSsHW06ZQxTEBJSxv7/HYAgf835zAPyrXfojm6y+x2AmhOpbvjMpSHQREmVVytkoFoC4wrWF2ld0ycS6esDxW2UyMzedzFglVX9XkdsQs+iLaJ/kPUu3O8UaLdOeUq/V20h9ruHYePtgh/sHkQSrkuNzUX4irrRQhBMwSnRb16sA6WAp60xvqcq5iaonsQmP/Gmy2wxzaBMWAn7yVwzNsIlltLT1uQx8QXJg09eaoBXGU03Ad4JqwWMuWwBDKTBx3G/msTQ8R54NqIR8+XzyLLtsPR0SCWAPT4QxNA9kuB9xg7mxORk0sd9otaYFcbjacmsV5QWXNGmJWgmwQQFeR1a7ZI+Mwe8PXEKu6O6q1ipmYT8Em5l9L1DnBRVw9Uw0SeL3gsF9WVXoafhGiUTdpxBWhnCTeqbm9w/zq7dLXXw3fmEANX/wjj2SApAQcF6GyrboDAbW1Z0vhdQpd3h00QzAoVJtepuSrb+mXt4SxZwcYOk8jZT2v/Zh6lxc3WvV8qjeUzpfL/YGGhSF0GazAmMbQf5kSq7yD+HtbdVXJzs5AUT/Dfbpod7EXRBt5AyfAKzNxhpVW4fBq1TCgY5R80CM8ZhBv5sWsXEU+qSTcLm0nQiMm9FWbe+1U+AdeQ8rGRzvj3c+nweD2AfkkTCK48Vo2mYULfhpUyH0RTR8BcwuQAXw9t7Ak6p83BQY5TP+pN8tSsQKabgHkNULhwsvg0AMyzomDEKKt7x+y5x3qc0jFv/L845K+c/A6MQJql3pr3NwiaBONVf8zcjBuGs7fGTCVYXiAZXyYcmQbHsKmazNygALqkavo8nwXACuj/zgJIriWqejcK4glZHMHBuYxyn1d8qTGYxO3SfI-MEYCIQCtUXO5w89Sia9rKhwXta5WIVVszmIUMafiXsmgjhdowwIhANvYch0ZhqO1LmojzxOtCmqSCu5ciHuOh/wspOTT5y2a',
  /* Stripe */
  stripePublicKey:
    'pk_test_51RlRCE02j1Jc4DjBn0ls4BpS1aJl1EFZ3oJjyhZX6TxUWJK5Dy48ZoeUcjZYYO4ekUBQ3uANxJZUK6CMeJByOXWU00AI9gYEWN',
};
